/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import {
  Switch,
  Route,
  HashRouter,
  useRouteMatch,
  Redirect,
} from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";

import { AuthLayout } from "./Layout/authLayout";
import { Layout } from "./Layout/metronicLayout";

import Login from "./Pages/Auth/Login";
import { Dashboard } from "./Pages/Dashboard/Dashboard";
import { routers } from "./Constants/router_paths";
import { OrganizationPage } from "./Pages/Organizations/OrganizationsPage";
import { ClientProfile } from "./Pages/ClientProfile/ClientProfile";
import { FeedsPage } from "./Pages/Feeds/FeedsPage";
import { RequestPage } from "./Pages/Requests/RequestPage";
import { EnterpriseRequestsPage } from "./Pages/EnterprisesRequests/EnterprisesRequests";


// const PrivateRoutes = ({ component: Page, authToken, ...rest }) => {
//   return (
//       <Route {...rest} render={props => {
//           return (
//               <>
//                   { authToken ? <Page {...props} /> : <Redirect to={routes.adminRoutes.login} />}
//               </>
//           )
//       }} />
//   );
// }

export function Routes() {
  const { accessToken } = useSelector(({ auth }) => auth, shallowEqual);
  const isAuthorized = !!accessToken;
  console.log("************");
  console.log(isAuthorized);

  return (
    <HashRouter>
      <Switch>
        {!isAuthorized ? (
          <Route path="/auth">
            <AuthRoutes />
          </Route>
        ) : (
          <Redirect from="/auth" to="/" />
        )}
        {isAuthorized ? <AuthorizedRoutes /> : <Redirect to="/auth/login" />}
      </Switch>
    </HashRouter>
  );
}

function AuthRoutes() {
  let { path } = useRouteMatch();

  return (
    <AuthLayout>
      <Switch>
        <Route path={`${path}/login`} component={Login} />
        <Route path={routers.clientProfile} component={ClientProfile} />
      </Switch>
    </AuthLayout>
  );
}

function AuthorizedRoutes() {
  return (
    <Layout>
      <Switch>
        <Route path={'/'} exact component={Dashboard} />
        <Route path={routers.coaches_clients} exact component={Dashboard} />
        <Route path={routers.organizations} component={OrganizationPage} />
        <Route path={routers.clientProfile} component={ClientProfile} />
        <Route path={routers.requests} component={RequestPage} />
        <Route path={routers.feeds} component={FeedsPage} />
        <Route path={routers.EnterpriseRequest} component={EnterpriseRequestsPage} />
      </Switch>
    </Layout>
  );
}
